import { IconAuthLoading } from '@f_components/icons/IconAuthLoading';
import stls from '@f_styles/components/loadings/LoadingPage.module.sass';

export function LoadingPage() {
    return (
        <div className={stls.container}>
            <IconAuthLoading classNames={[stls.icon]} />
        </div>
    );
}
